import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaService } from 'src/app/services/media.service';
import { PageService } from 'src/app/services/page.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class PrivacyComponent implements OnInit {

  pagedata:any = null;

  constructor(private pageService:PageService, private mediaService:MediaService) { }

  ngOnInit(): void {
    this.pageService.getPage("privacy").subscribe(data => {
      this.pagedata = data.data;

      this.pagedata.foto1 = this.mediaService.getMediaItemUrl(this.pagedata.foto1);
      this.pagedata.foto2 = this.mediaService.getMediaItemUrl(this.pagedata.foto2);
    });
  }

}
